<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-account-plus-outline
        </v-icon>Create Permission
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="newPermissionName"
                  label="Name"
                  dense
                  outlined
                  hint="Name for your reference-'read-content'."
                  :rules="[(v) => !!v || 'This field is required']"
                  persistent-hint
                  @keydown.space.prevent
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="selectedPermissionCategory"
                  :items="permissionCategoryList"
                  item-value="name"
                  item-text="name"
                  label="Select Permission Category"
                  :rules="[(v) => !!v || 'This field is required']"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <br>
            <v-textarea
              v-model="permissionDescription"
              filled
              label="Description about the permission*"
              :rules="[(v) => !!v || 'This field is required']"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createPermission()"
            >
              create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  export default {
    data () {
      return {
        showModal: true,
        isFormValid: false,
        newPermissionName: '',
        selectedPermissionCategory: '',
        permissionDescription: '',
      };
    },
    computed: {
      permissionCategoryList () {
        return this.$store.getters['accountcontrol/getPermissionCategoryList'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.$store.dispatch('accountcontrol/fetchPermissionCategoryList');
    },
    methods: {
      createPermission () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('accountcontrol/createNewPermission', {
            name: this.newPermissionName,
            category: this.selectedPermissionCategory,
            description: this.permissionDescription,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Permission created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.showModal = false;
          });
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
